import { render, staticRenderFns } from "./upload-loading.vue?vue&type=template&id=2f3ecd7c"
var script = {}
import style0 from "./upload-loading.vue?vue&type=style&index=0&id=2f3ecd7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports